var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container flex-centerize flex-column"},[_c('InstallationContent',_vm._g(_vm._b({attrs:{"forceInstall":_vm.forceInstall,"installableId":_vm.installableId,"avoidRedirection":_vm.avoidRedirection}},'InstallationContent',_vm.$attrs,false),_vm.$listeners)),_c('AppDialogManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }